// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ea32154","780":"e8660643"}[chunkId] + ".chunk.js";
};